//DNA
import useDecodeToken from "@/utils/hooks/useDecodeJwt";
import dataManagement from "@/navigation/data-management";
import inventory from "@/navigation/inventory";
import privileges from "@/navigation/privileges";
import report from "@/navigation/report";
import banner from "@/navigation/banner";
import tags from "@/navigation/tags";
import fulfillment from "@/navigation/fulfillment";
import document from "@/navigation/document";
import article from "@/navigation/article";
import survey from "@/navigation/survey";

const { decodeToken } = useDecodeToken();
const renderNavByPermission = () => {
  switch (decodeToken()?.provider_ref) {
    case "PVvrLSAmEeiJ4o": // Dev Dna BO EP
    case "PVL910gMNsG3Fb": // Prod Dna BO EP
      switch (decodeToken()?.sub) {
        case "ID_vsYvv84HEGHJ": //Dev dutchmill.dna@gmail.com
        case "ID_ER9xTCCL88Yw": //Prod dutchmill.dna@gmail.com
          return [...report];
      }
    default:
      return [
        ...privileges,
        ...article,
        ...dataManagement,
        ...inventory,
        ...fulfillment,
        ...document,
        ...report,
      ];
  }
};

export default renderNavByPermission();
